const locale = {
  GET_NOTIFIED_NEW_INSPECTION: `Recevoir un mail des rapports faits par cet utilisateur`,
  ACCESS_NEW_INSPECTION_MSA: `Autonomie sur les demandes d'Inspections MSA`,
  NOTIFY_USER_MAIL: `Ne pas notifier l'utilisateur de la création du compte`,
};

export default locale;
